import React from "react";
import {TabDefinition, TabsContentPage} from "../shared/components/tabs/TabsContentPage";
import {UsersPageContent} from "./users/UsersPageContent";
import {CompaniesPageContent} from "./companies/CompaniesPageContent";
import {StandardRole} from "./users/Role";

export function UsersAndDataPage() {
  const tabs: TabDefinition[] = [
    {
      titleKey: 'User.title',
      component: <UsersPageContent/>,
      visibleForRoles: [StandardRole.ADMIN, StandardRole.APPLICATION_ADMIN, StandardRole.COMPANY_ADMIN]
    },
    {
      titleKey: 'Company.title',
      component: <CompaniesPageContent/>,
      visibleForRoles: [StandardRole.ADMIN, StandardRole.APPLICATION_ADMIN]
    },
  ];
  return (
    <TabsContentPage tabs={tabs}/>
  )
}
